// @ts-nocheck
import { initialState, name } from "../../reducer";

const companySettings = (state) => state[name] || initialState;

export const getDocuments = (state) => companySettings(state).documents;
